import { useChainId } from "wagmi";

import { CurrencyCardWithBalance } from "entities/currency";
import { bentoUSDConfig, bentoUSDPlusConfig } from "shared/config/const";

import { Activity } from "./ui/activity/activity";

export const Assets = () => {
  const chainId = useChainId();
  const bento = bentoUSDConfig[chainId];
  const bentoPlus = bentoUSDPlusConfig[chainId];

  return (
    <>
      <div
        className={`mt-7.5 grid grid-cols-1 gap-1.5 overflow-hidden md:grid-cols-2`}
      >
        <CurrencyCardWithBalance
          className="w-full"
          currency={bento}
          link="https://HARDCODE"
        />
        <CurrencyCardWithBalance
          style={{
            backgroundImage: `
                linear-gradient(0deg, rgba(41, 41, 41, 0.3), rgba(41, 41, 41, 0.3)), radial-gradient(310.86% 310.86% at 18.38% -199.39%, rgba(34, 237, 78, 0.3) 0%, rgba(34, 237, 78, 0) 100%)
              `,
          }}
          className="w-full"
          currency={bentoPlus}
          link="https://HARDCODE"
        />
      </div>

      <Activity className="mt-17.5" />
    </>
  );
};
